import left from './left.jpg'
import right from './right.jpg'

export { right, left }



// WEBPACK FOOTER //
// ./src/components/Header/images/index.js